import { render, staticRenderFns } from "./default-before-login-v2.vue?vue&type=template&id=0380efa4&lang=pug"
import script from "./default-before-login-v2.vue?vue&type=script&lang=js"
export * from "./default-before-login-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports